import React, { useState, useRef, useEffect } from 'react'
import PrivateSpaceIcon from '../PrivateSpaceIcon/PrivateSpaceIcon'
import styles from './SpaceDropdown.module.css'

const SpaceDropdown = ({ spaces, activeTab, onTabChange, isOpen, onToggle }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const dropdownRef = useRef(null)

  const toggleDropdown = () => onToggle()

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      if (isOpen) onToggle()
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const filteredSpaces = spaces.filter((space) => space.label.toLowerCase().includes(searchTerm.toLowerCase()))

  const handleSpaceClick = (key) => {
    onTabChange(key)
  }

  const isAnyHiddenSpaceActive = spaces.some((space) => space.key === activeTab)
  const isActive = isOpen || isAnyHiddenSpaceActive

  return (
    <div className={styles.container} ref={dropdownRef}>
      <button
        type="button"
        className={`${styles.moreButton} ${isActive ? styles.tabActive : ''}`}
        onClick={toggleDropdown}
      >
        More
        <img
          src={isOpen ? '/assets/icons/chevron-up.svg' : '/assets/icons/chevron-down.svg'}
          alt="chevron"
          className={styles.chevron}
        />
      </button>

      {isOpen && (
        <div className={styles.dropdown}>
          <div className={styles.searchContainer}>
            <input
              type="text"
              placeholder="What are you looking for?"
              className={styles.searchInput}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
            <img src="/assets/icons/search.svg" alt="search" className={styles.searchIcon} />
          </div>
          <div className={styles.list}>
            {filteredSpaces.length > 0 ? (
              filteredSpaces.map((space) => (
                <button
                  key={space.key}
                  className={`${styles.item} ${activeTab === space.key ? styles.itemActive : ''}`}
                  onClick={() => handleSpaceClick(space.key)}
                >
                  <div className={styles.nameSection}>
                    {space.isPrivate && <PrivateSpaceIcon />}
                    <span className={styles.name}>{space.label}</span>
                    {space.count !== null && <span className={styles.count}>{space.count}</span>}
                  </div>
                  <img src={'/assets/icons/arrow-right.svg'} alt="arrow" className={styles.arrow} />
                </button>
              ))
            ) : (
              <div className={styles.noResults}>No spaces found</div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default SpaceDropdown
